import { $, _, moment, Backbone, Foundation, Radio } from "../../../../vendor";
import { Backform, Notification, Biscuit, OpeningTimes } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";
import t from "../../../react/helpers/t";
import Reservation from "../../../models/Reservation";

import {
  GetContingentItemVoucherFields,
  MapContingentsFromRawToSave,
  MapContingentsFromRawToGetPrice,
  MapProductsFromRawToSave,
  MapProductsFromRawToGetPrice,
  MapContingentsFromRawToDisplayable,
  MapContingentsReservationsToSummedContingents,
  MapProductsReservationsToSummedProducts,
  GetPriceHelper,
  WeekdaysMap,
} from "./ReservationFormHelpers";
import ReservationContingentsList from "./ReservationContingentsList";
import ReservationProductsList from "./ReservationProductsList";
import ContingentsOverviewList from "./ContingentsOverviewList";
import ProductsOverviewList from "./ProductsOverviewList";

import ReservationItemTpl from "../../../templates/orders/ReservationForm/ReservationItemTpl.html";
import { getApiHost, getRequestHeaders } from "../../../Sync";
import { getDocHandler } from "../../../utils/Helper";

/**
 * BIKES INBOOMA BOOKING FORM
 *
 * Used for vehicles resourcetype.
 * Allows selection of MULTIPLE contingents per booking.
 *
 */
export default InboomaBaseView.extend({
  preventFromSubmit: false, // Required for external access, e.g. QuickOrderForm.js
  _previousModelState: {}, // "Unset my latest action" feature
  showPriceWrapper: false,
  template: ReservationItemTpl,
  className: "",

  ui: {
    errorLabel: ".off-canvas__form-error.main-error",
    addContingentBtn: ".contingents__add a",
    addProductBtn: ".products__add a",
    accordionTitle: ".accordion-title",
    accordionContent: ".accordion-content",
    reservationRequiresSave: ".reservation-requires-save",
    orderExportContract: ".order_export_contract",
  },

  events: {
    "click @ui.addContingentBtn": "_toggleContingentsOverviewView",
    "click @ui.addProductBtn": "_toggleProductsOverviewView",
    "click @ui.accordionTitle": "_toggleAccordion",
    "click @ui.orderExportContract": "_printRentalContract",
  },

  modelEvents: {
    "change:price": "_totalPriceChanged",
    "change:summedContingents": "_setSummedContingents",
    "change:summedProducts": "_setSummedProducts",
  },

  templateContext() {
    return {
      _,
      moment,
      toggleOpen: this.options.toggleOpen || this.model.get("id") === "",
      apiHost: getApiHost().slice(0, -4),
      indexNumber: this.options.indexNumber,
      showPriceWrapper: this.showPriceWrapper,
      // @todo Remove hard-coded link once "Mietvertrag" has become part of the
      // standard web frontend. Once done, put isDefaultForm to "false".
      isDefaultForm: Number(Biscuit.get("user.client_id")) !== 7,
      currency: Biscuit.getClientCurrency(),
    };
  },

  initialize() {
    const that = this;

    // The following line has proofen to be like a juice booth in the desert...
    console.log("DEBUG: RESERVATION ELEMENT", this.model.toJSON());

    if (this.model.get("tag_list") == "school_bonus" || this.model.get("school_bonus")) {
      this.model.attributes["_school_bonus_field_visible"] = true;
      this.model.attributes["school_bonus"] = true;
    } else {
      this.model.attributes["_school_bonus_field_visible"] = false;
      this.model.attributes["school_bonus"] = false;
    }

    let blocked_end = this.model.attributes.blocked_end;
    this.model.attributes.blocked_unit = "days";

    if (blocked_end !== null && blocked_end !== "" && blocked_end.length >= 3) {
      // From timestamp to int (count of days)
      blocked_end = moment(this.model.get("end"), "YYYY-MM-DD HH:mm").diff(
        moment(blocked_end, "YYYY-MM-DD HH:mm"),
        "hours",
      );
      blocked_end *= -1;
      if (Number(blocked_end) >= 24 || Number(blocked_end) == 0) {
        this.model.attributes.blocked_end = blocked_end / 24; // set hours to days
      } else {
        this.model.attributes.blocked_unit = "hours";
        this.model.attributes.blocked_end = blocked_end;
      }
    }

    if (typeof this.model.attributes.summedContingents === "undefined") {
      MapContingentsReservationsToSummedContingents(this.model);
    }

    if (typeof this.model.attributes.summedProducts === "undefined") {
      MapProductsReservationsToSummedProducts(this.model);
    }

    // Additionaly, save the original / inital selections for later use

    if (typeof this._originalSelectedUnits === "undefined") {
      this._originalSelectedUnits = {};

      _.each(this.model.attributes.summedContingents, function (collection, contingent_id) {
        that._originalSelectedUnits[contingent_id] = collection.models.length;
      });
    }
  },

  _printRentalContract(target) {
    const t = $(target.currentTarget),
      rid = t.attr("data-inb-reservation");

    /*let ref = "" + getApiHost();
        ref = ref.slice(0, -4) + "/rental_contract/" + rid + "/1";
        window.open(ref,'_blank');*/
    console.log("here?");
    getDocHandler(
      "/rental_contract/" + rid,
      "GET",
      "application/pdf",
      this.t("reservation") + "-" + this.model.attributes.order.order_nbr + ".pdf",
      "",
      rid,
    );
  },

  _recheckRequestInProgress: false,

  /**
   * @method _recheckForRemainingContingents
   *
   * Called after e.g. reservation.begin, .end, & -location value changes
   * Fetches real time availabilities from API, checks for invalid combinations of contingents and return_station
   * in order to, eventually, update contingentList
   */
  _recheckForRemainingContingents() {
    if (
      this._recheckRequestInProgress ||
      moment(this.model.get("begin")).isAfter(moment(this.model.get("end")))
    ) {
      // Aborting as model would fail validation
      return;
    }

    this._recheckRequestInProgress = true;

    const that = this,
      RequestHelper = Backbone.Model.extend({
        url: "/contingents/getAvailabilityForAll",
      }),
      requestHelper = new RequestHelper({
        begin: this.model.get("begin") + (this.model.get("begin").length < 19 ? ":00" : ""),
        end: this._getBlockedEnd(),
        //'client_id' : Number(Biscuit.get('user.client_id')),
        location_id: this.model.get("begin_location"),
      });

    if (this.model.get("id") !== "" && this.model.get("id") !== null) {
      requestHelper.set("reservation_id", this.model.get("id"));
    }

    requestHelper.save(null, {
      success(model, contingentIdHasAmount) {
        let tempData = contingentIdHasAmount.data,
          newData = {};
        _.each(tempData.locations[0].contingents, function (contingent) {
          let id = contingent.id;
          newData[id.toString()] = contingent.available;
        });
        contingentIdHasAmount = newData;

        const locations = Radio.channel("dynamo_start_locations"),
          begin_location = locations.request(
            "getLocationById",
            Number(that.model.get("begin_location")),
          );
        if (typeof begin_location.get("end_locations") === "undefined") {
          that._recheckRequestInProgress = false;
          return;
        }

        let end_location =
          begin_location.get("end_locations")[that.model.get("end_location").toString()];

        const stationHasContingentCombination = (contingent_id) => {
          // Deep scan on whether return station has that contingent assigned

          let contingentsArr = end_location.contingents;
          let extraProducts = end_location.extra_products;
          _.each(extraProducts, function (prod, hh) {
            _.each(prod, function (pr) {
              if (pr.availability_check) {
                contingentsArr[hh.toString()] = prod;
              }
            });
          });
          let result = false;
          _.each(contingentsArr, (contingentList) => {
            if (result) return;

            if (typeof contingentList[contingent_id.toString()] !== "undefined") {
              result = true;
            }
          });

          return result;
        };
        const estimateDeletedContingents = function (unsetContingents = false) {
          let deleted = {};
          _.each(that.model.get("summedContingents"), function (contingent, contingent_id) {
            // Check whether contingent numbers in active contingentList are still bookable
            // If they aren't, smartly reduce their total number and throw a notification

            const contingent_name =
              contingent.models[0].get("name") + contingent.models[0].getFormattedTags();

            deleted[contingent_name] = 0;

            const newAmount = contingentIdHasAmount[contingent_id];
            console.log(contingent_name, "contingent_name");
            let contingentAmount = contingent.models.length;
            if (typeof newAmount === "undefined" || isNaN(newAmount)) {
              // -- Option I --
              // Unset original contingent completely

              for (
                let i = 0;
                i < that.model.get("summedContingents")[contingent_id].models.length;
                i++
              ) {
                deleted[contingent_name]++;
              }

              if (unsetContingents) {
                delete that.model.get("summedContingents")[contingent_id];
                that.model.trigger("removedContingent", contingent_id);
              }
            } else if (newAmount < contingentAmount) {
              // -- Option II --
              // Remove units from contingent view
              while (newAmount < contingentAmount) {
                if (unsetContingents) {
                  contingent.remove(contingent.models[contingent.models.length - 1]);
                }

                contingentAmount--;
                deleted[contingent_name]++;
              }
            }

            if (deleted[contingent_name] === 0) {
              // No actions done, remove from counter
              delete deleted[contingent_name];
            }
          });

          return deleted;
        };

        // 1. Calculate contingent items that'd be deleted.
        // 2. If there are any and user does not confirm action,
        //    set model state back to previous selection.
        // this refs #20641

        const deletedContingents = estimateDeletedContingents();

        let deletedCount = 0; // Display to user the amount of deleted items

        if (_.size(deletedContingents) >= 1) {
          let formattedDeletedContingents = "";

          _.each(deletedContingents, function (c, name) {
            formattedDeletedContingents +=
              (formattedDeletedContingents !== "" ? ", " : "") + (name + " (x " + c + ")");
            deletedCount += c;
          });
          that.model.set(_.clone(that._previousModelState));
          that._previousModelState = {};
          that._recheckRequestInProgress = false;
          that.getPrice();
          alert(that.t("really_delete_${a}_contingent_items", { a: formattedDeletedContingents }));
          return;

          if (
            !confirm(
              that.t("really_delete_${a}_contingent_items", { a: formattedDeletedContingents }),
            )
          ) {
            // Reset previous model state
            that.model.set(_.clone(that._previousModelState));
            that._previousModelState = {};
            that._recheckRequestInProgress = false;

            return;
          }
        } else {
          return;
        }

        estimateDeletedContingents(false);

        let message =
          deletedCount >= 1 ? that.t("${a}_contingents_deleted", { a: deletedCount }) + "\n" : "";

        if (message !== "") {
          new Notification({
            message:
              message +
              ". " +
              (that.model.get("id") !== "" ? that.t("action_requires_booking_save") : ""),
            duration: 7000,
            closeable: true,
            icon: "fi fi-check",
          });

          that.model.trigger("change:summedContingents");
          that.getPrice();
        }

        that._recheckRequestInProgress = false;
      },
      error() {
        console.log("ERROR in _recheckForRemainingContingents");
        that._recheckRequestInProgress = false;
      },
    });
  },

  _setReturnLocations() {
    const that = this,
      locations = Radio.channel("dynamo_start_locations").request("get:data");
    let beginLocation = locations.find({ begin_location_id: that.model.get("begin_location") });
    if (typeof beginLocation == "undefined") {
      beginLocation = locations.find({ location_id: that.model.get("begin_location") });
    }

    let returnLocations = [
      {
        label: "- " + InboomaBaseView.prototype.t("no_return_station_found") + " -",
        value: "",
      },
    ];

    let activeReturnLocationInNewList = false;
    if (typeof beginLocation !== "undefined") {
      returnLocations = _.sortBy(
        _.map(beginLocation.get("end_locations"), (location, location_id) => {
          if (location_id == that.model.get("end_location")) {
            activeReturnLocationInNewList = true;
          }

          return {
            label:
              typeof location == "undefined"
                ? "- Unbekannter Standort #" + location_id + " -"
                : location.name,
            value: Number(location_id),
          };
        }),
        (location) => {
          if (that.model.get("begin_location") === location.value) {
            return "0";
          }
          return location.label;
        },
      );
    }

    if (!activeReturnLocationInNewList) {
      // Unset model.end_location so that a new value
      // can be auto-set in Backform.ts (around l590)
      that.model.attributes.end_location = "";
    }

    that.model.set("_return_locations", returnLocations);
    that.model.trigger("change:end_location");
  },

  onRender() {
    let backformReady = false;

    this.model.set(
      "_begin_locations",
      Radio.channel("dynamo_start_locations").request("get:data:list"),
    );

    const that = this,
      modelIsNew = this.model.get("id") === "";

    if (typeof this.model.get("_return_locations") == "undefined") {
      this.model.set("_return_locations", [
        { label: that.t("loading_return_stations_progress"), value: "" },
      ]);
    }

    this.model._modelUpdatedByUser = false;

    const locations = Radio.channel("dynamo_start_locations");

    this.model.on("change:begin_location", function () {
      locations.trigger("fetchBeginLocation", that.model, function () {
        that._setReturnLocations();
      });
    });

    if (this.model.get("id") != "") {
      locations.trigger("fetchBeginLocation", that.model, function () {
        that._setReturnLocations();
      });
    }

    const vouchers = Radio.channel("vouchers").request("get:data");

    let _availableCodes = _.map(vouchers, (voucher) => ({
      value: typeof voucher === "undefined" ? 0 : voucher.id,
      label: typeof voucher === "undefined" ? "" : voucher.get("voucher_code"),
    }));

    let fields = [];

    if (typeof this.model.get("_has_any_deleted_item") === "undefined") {
      fields = [
        {
          name: "begin_location",
          label: this.t("begin"),
          required: true,
          disabled: this.model.get("id") != "",
          forceFirstSelected: true,
          options: this.model.get("_begin_locations"),
          size: {
            small: "12",
            large: "5",
          },
          extraTopClasses: ["form-block-top"],
          control: Backform.SelectorControl.extend({
            initialize() {
              Backform.SelectorControl.prototype.initialize.apply(this, arguments);
              this.listenTo(this.model, "change:begin_location", that._setReturnLocations);
              this.listenTo(this.model, "backform:change:date", function (field, timeChanged) {
                // Date/Time changed: Fetch new price

                const timeAlreadyOverriden = that
                  .$(`.inb-form-group.${field} input.datepicker-time`)
                  .hasClass("is-invalid-input");

                if (!timeChanged && !timeAlreadyOverriden) {
                  // Day changed: Auto-set time from openingTimes
                  if (that.model.get("id") === "") {
                    that._autoSetOpeningTime(field, false);
                  }
                }

                if (_.size(that._reservationContingentsListViews) >= 1) {
                  that.getPrice();
                }
              });

              // @changed change:begin
              this.listenTo(
                this.model,
                "change:begin_location change:_return_locations",
                function (resetBeginTime) {
                  // Keep all these listeners here as they depend on the right
                  // rendering of the form at the right time (unfortunately...)

                  if (that.model.get("id") === "" && resetBeginTime !== false) {
                    that._autoSetOpeningTime("begin");
                  }

                  if (backformReady) {
                    if (_.size(that._reservationContingentsListViews) >= 1) {
                      that.getPrice();
                    }

                    if (!this.model._modelUpdatedByUser) {
                      this.field.attributes.options = that.model.get("_begin_locations");
                      this.render();

                      if (that.model.get("id") === "" && resetBeginTime !== false) {
                        that._autoSetOpeningTime("begin");
                      }
                    } else {
                      this.model._modelUpdatedByUser = false;
                    }
                  }
                },
              );
            },
          }),
        },
        {
          name: "end_location",
          label: this.t("end"),
          required: false,
          forceFirstSelected: true,
          options: this.model.get("_return_locations"),
          size: {
            small: "12",
            large: "5",
          },
          extraTopClasses: ["form-block-top"],
          control: Backform.SelectorControl.extend({
            initialize() {
              Backform.SelectorControl.prototype.initialize.apply(this, arguments);

              this.listenTo(
                this.model,
                "change:end_location change:_return_locations",
                function (triggerAutoSetOpeningTimes = true) {
                  this.field.attributes.options = that.model.get("_return_locations");
                  this.render();

                  if (backformReady && _.size(that._reservationContingentsListViews) >= 1) {
                    that.getPrice();
                  }

                  // If triggerAutoSetOpeningTimes is false, the change:end event was fired
                  // within _autoSetOpeningTime('end') so it ends here.
                  if (that.model.get("id") === "" && triggerAutoSetOpeningTimes) {
                    that._autoSetOpeningTime("end");
                  }
                },
              );

              this.listenTo(this.model, "change:end", function () {
                if (backformReady && _.size(that._reservationContingentsListViews) >= 1) {
                  that.getPrice();
                }

                if (that.model.get("id") === "" && backformReady) {
                  that._autoSetOpeningTime("end");
                }
              });

              this.listenTo(this.model, "change:end", function () {
                if (_.size(that._reservationContingentsListViews) >= 1) {
                  that.getPrice();
                }
              });
            },
          }),
        },
        {
          name: "blocked_end",
          label: this.t("service_transport", null, "capital"),
          control: "input",
          extraTopClasses: ["form-block-transport"],
          size: {
            large: "1",
          },
        },
      ];
      fields.push({
        // select hours
        name: "blocked_unit",
        label: "&nbsp;",
        control: "select",
        options: [
          { label: that.t("hours", null, "capital"), value: "hours" },
          { label: that.t("days", null, "capital"), value: "days" },
        ],
        size: {
          large: "1",
        },
      });
      fields.push(
        {
          // FAKE field which is required to actually enable the focusin/-out
          // events of the two following datetimepicker
          name: "hide",
          control: "datetimepicker",
          label: "fake",
          openingTimesModel: {},
        },
        {
          name: "begin",
          //minDate: (this.model.get('id') == '' ? new Date() : moment(this.model.get('begin')).toDate()),
          // minDate: If it stays at new Date(), past reservations will be auto-set to today by pikaday :(
          // We therefore skip this issue for now
          // Desired behavior see #19410
          openingTimesModel: {},
          extraTopClasses: ["hide-group-label", "form-block-bottom"],
          size: {
            small: "11",
            large: "5",
          },
          triggerPicker: "end",
          control: Backform.DatetimepickerControl.extend({
            initialize() {
              Backform.DatetimepickerControl.prototype.initialize.apply(this, arguments);

              // Sometimes the openingtimes-setter further down is not being called
              // we therefore force the field to generate openingtimes at the very beginning
              this.field.attributes.openingTimesModel = locations.request(
                "getLocationById",
                this.model.get("begin_location"),
              );

              //this.render();

              this.listenTo(this.model, "change:begin_location change:begin", function () {
                this.field.attributes.openingTimesModel = locations.request(
                  "getLocationById",
                  this.model.get("begin_location"),
                );
                this.render();
              });
            },
          }),
        },
        {
          name: "end",
          //minDate: (this.model.get('id') == '' ? new Date() : moment(this.model.get('end')).toDate()),
          // minDate: Discussion see above
          openingTimesModel: {},
          extraTopClasses: ["hide-group-label", "form-block-bottom"],
          size: {
            small: "11",
            large: "5",
          },
          control: Backform.DatetimepickerControl.extend({
            initialize() {
              Backform.DatetimepickerControl.prototype.initialize.apply(this, arguments);
              this.listenTo(
                this.model,
                "change:end_location change:_return_locations",
                function () {
                  this.field.attributes.openingTimesModel = locations.request(
                    "getLocationById",
                    this.model.get("end_location"),
                  );
                  this.render();
                },
              );
            },
          }),
        },
        {
          name: "reservation-contingents-list",
          control: "fillable",
        },
        {
          name: "reservation-products-list",
          control: "fillable",
        } /*{
                    name: "_voucher_types",
                    label: "Gutschein für gesamte Buchung",
                    control: "select",
                    size : {
                        "large" : "4"
                    },
                    extraTopClasses : []
                },*/,
        {
          name: "space",
          control: "fillable",
          size: {
            large: "12",
          },
        },
        {
          name: "status",
          label: this.t("status", null, "capital"),
          control: "select",
          required: true,
          // @todo make disabled if reservation from past
          options: [
            // TODO: appRadio.get('order-select-states')
            {
              label: that.t("completed", null, "capital"),
              value: "completed",
              disabled: false,
            },
            {
              label: that.t("confirmed", null, "capital"),
              value: "confirmed",
              disabled: false,
            },
            {
              label: that.t("requested", null, "capital"),
              value: "requested",
              disabled: false,
            },
            {
              label: that.t("inprogress", null, "capital"),
              value: "inprogress",
              disabled: false,
            },
            {
              label: that.t("cancelled", null, "capital"),
              value: "cancelled",
              disabled: false,
            },
          ],
          size: {
            large: "4",
          },
        },
        {
          name: "status",
          label: "i",
          control: "select",
          size: {
            large: "4",
          },
          extraTopClasses: ["invisible"],
        },
        {
          name: "voucher_code",
          label: this.t("discount_number", null, "capital"),
          forceFirstSelected: undefined,
          forceSelectedOption: () => {
            return { value: that.model.get("voucher_id"), label: that.model.get("voucher_code") };
          },
          control: "selector",
          options: _availableCodes,
          extraTopClasses: [""],
          select2Options: {
            rememberSearch: true,
            closeOnSelect: false,
            ajax: {
              url: getApiHost() + "/vouchers",
              headers: getRequestHeaders(),
              dataType: "json",
              delay: 250,
              data: (params) => ({
                q: params.term,
                page: params.page,
                limit: 10,
              }),
              processResults: (data, params) => ({
                results: _.map(data.data, (item) => ({
                  id: item.id,
                  text: item.voucher_code,
                })),
                pagination: {
                  more: data.pagination.has_next_page,
                },
              }),
            },
            minimumInputLength: 0,
            casesensitive: false,
          },
          size: {
            large: "4",
          },
        },
        {
          name: "school_bonus",
          label: this.t("school_bonus"),
          showAsToggle: false,
          size: {
            small: "4",
            large: "4",
          },
          control: Backform.BooleanControl.extend({
            initialize() {
              Backform.BooleanControl.prototype.initialize.apply(this, arguments);

              this.listenTo(this.model, "change:school_bonus", function () {
                that.getPrice();
                return true;
              });

              this.$el.toggleClass("invisible", !this.model.get("_school_bonus_field_visible"));

              this.listenTo(this.model, "change:_school_bonus_field_visible", function () {
                this.$el.toggleClass("invisible", !this.model.get("_school_bonus_field_visible"));

                if (!this.model.get("_school_bonus_field_visible")) {
                  this.model.set("school_bonus", false);
                }
              });
            },
          }),
        },
        {
          name: "status",
          label: "i",
          control: "select",
          size: {
            large: "4",
          },
          extraTopClasses: ["invisible"],
        },
        {
          name: "status",
          label: "i",
          control: "select",
          size: {
            large: "4",
          },
          extraTopClasses: ["invisible"],
        },
        {
          name: "price",
          helpMessage: " ",
          label: this.t("price_total"),
          groupLabelBackwards: Biscuit.getClientCurrency(),
          hasLock: true,
          size: {
            small: "4",
          },
          control: Backform.InputControl.extend({
            initialize() {
              Backform.InputControl.prototype.initialize.apply(this, arguments);

              // Alerta, alerta: Changes to reservation.price itself are handled in _totalPriceChanged
              this.listenTo(this.model, "change:manual_override", function () {
                if (!this.model.get("manual_override")) {
                  that.getPrice();
                }

                this.$(".r-contingent-lock").toggleClass(
                  "hide",
                  !this.model.get("manual_override"),
                );
              });
            },
          }),
        },
        {
          name: "external_note",
          label:
            this.t("notes_external", null, "capital") +
            " (" +
            this.t(
              "still_chars_available_${a}",
              {
                a:
                  255 -
                  (typeof this.model.get("external_note") !== "undefined" &&
                  this.model.get("external_note") !== null &&
                  this.model.get("external_note") !== ""
                    ? Number(this.model.get("external_note").length)
                    : 0),
              },
              "capital",
            ) +
            ")",
          control: "textarea",
          size: {
            small: "12",
          },
        },
        {
          name: "internal_note",
          label:
            this.t("notes_internal", null, "capital") +
            " (" +
            this.t(
              "still_chars_available_${a}",
              {
                a:
                  255 -
                  (typeof this.model.get("internal_note") !== "undefined" &&
                  this.model.get("internal_note") !== null &&
                  this.model.get("internal_note") !== ""
                    ? Number(this.model.get("internal_note").length)
                    : 0),
              },
              "capital",
            ) +
            ")",
          control: "textarea",
          size: {
            small: "12",
          },
        },
        {
          control: "button",
          label: that.t("save_${a}", { a: this.t("reservation") }),
          extraTopClasses: ["button-submit-wrapper"],
          extraClasses: [
            this.model.get("begin") == "" && this.model.get("end") == "" ? "hollow" : "",
          ],
          size: {
            small: "6",
          },
        },
      );
    }
    /*
        fields.push({
            name : "remove-reservation",
            control: 'uneditable-input',
            extraTopClasses: ['fake-link'],
            label: (modelIsNew ? this.t('abort',null,'capital') : this.t('remove',null,'capital')),
            size : {
                "small" : "6",
            }
        });
        */
    // Map i18n library to Backform
    this.model._t = this.t;

    this.form = new Backform.Form({
      el: this.$el.find("form"),
      model: this.model,
      fields,
      events: {
        "click .select2-results__option": (e) => {
          console.log("voucher code sel2 changed: ", e.currentTarget.value);
          that.model.set("voucher_code", e.target.value);
          that.getPrice();
        },
        'change selector[name="voucher_code"]'(e) {
          console.log("voucher code changed");
          that.model.set("voucher_code", e.currentTarget.value);
          that.getPrice();
        },
        'change select[name="blocked_unit"]'(e) {
          // get the right value field
          var val = e.target.options[e.target.selectedIndex].value;
          that.model.set("manualBuffertime", true);
          if (val == '"days"') {
            // current value in model is in hours
            var hours = that.model.attributes.blocked_end;
            that.model.set("blocked_end", hours / 24);
          } else if (val == '"hours"') {
            // current value in model is in days
            var days = that.model.attributes.blocked_end;
            that.model.set("blocked_end", days * 24);
          }
        },
        'keydown textarea[name="internal_note"]'(e) {
          let l = e.currentTarget.value.length;
          /*  if(typeof e.currentTarget.defaultValue !== 'undefined'){
                        l = e.currentTarget.defaultValue.length;
                    }*/
          if (e.originalEvent.keyCode === 8 || e.originalEvent.keyCode === 13) {
            if (l > 0) {
              l -= 1;
            }
          } else {
            l += 1;
          }

          if (l > 255) {
            l -= 1;
            return false;
          }
          that
            .$('textarea[name="internal_note"]')
            .parent("div")
            .parent("div")
            .children("label")
            .text(
              that.t("notes_internal", null, "capital") +
                " (" +
                that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                ")",
            );
        },
        'keydown textarea[name="external_note"]'(e) {
          let l = e.currentTarget.value.length;
          /*if(typeof e.currentTarget.defaultValue !== 'undefined'){
                        l = e.currentTarget.defaultValue.length;
                    }*/

          if (e.originalEvent.keyCode === 8 || e.originalEvent.keyCode === 13) {
            if (l > 0) {
              l -= 1;
            }
          } else {
            l += 1;
          }

          if (l > 255) {
            return false;
          }
          that
            .$('textarea[name="external_note"]')
            .parent("div")
            .parent("div")
            .children("label")
            .text(
              that.t("notes_external", null, "capital") +
                " (" +
                that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                ")",
            );
        },
        'change textarea[name="external_note"]'(e) {
          let l = e.currentTarget.value.length;
          //l += 1;
          if (l > 255) {
            alert(
              that.t(
                "text_limited_for_chars_${a}_${b}",
                {
                  a: that.t("notes_external", null, "capital"),
                  b: e.currentTarget.value.length - 255,
                },
                "capital",
              ),
            );
            e.currentTarget.value = e.currentTarget.value.substr(0, 255);
            that
              .$('textarea[name="external_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_external", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 0 }, "capital") +
                  ")",
              );
            that.model.set("external_note", e.currentTarget.value);
          } else {
            that
              .$('textarea[name="external_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_external", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                  ")",
              );
          }
        },
        'change textarea[name="internal_note"]'(e) {
          let l = e.currentTarget.value.length;
          //l += 1;
          if (l > 255) {
            alert(
              that.t(
                "text_limited_for_chars_${a}_${b}",
                {
                  a: that.t("notes_internal", null, "capital"),
                  b: e.currentTarget.value.length - 255,
                },
                "capital",
              ),
            );
            e.currentTarget.value = e.currentTarget.value.substr(0, 255);
            that
              .$('textarea[name="internal_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_internal", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 0 }, "capital") +
                  ")",
              );
            that.model.set("internal_note", e.currentTarget.value);
          } else {
            that
              .$('textarea[name="internal_note"]')
              .parent("div")
              .parent("div")
              .children("label")
              .text(
                that.t("notes_internal", null, "capital") +
                  " (" +
                  that.t("still_chars_available_${a}", { a: 255 - Number(l) }, "capital") +
                  ")",
              );
          }
        },
        "click .button[type='submit']"(ev) {
          ev.preventDefault();

          that.getUI("errorLabel").addClass("hide");

          that
            .$("form .is-invalid-input")
            .not(".datepicker-time") // As this carries overriden times
            .removeClass("is-invalid-input");

          //that.$el.find('form').foundation('validateForm');
          if (
            that._hasAllRequiredAttributesSet() &&
            that.model.isValid() &&
            !that.$("form .is-invalid-input").not(".datepicker-time").length
            /*&& that._validateVouchers()*/
          ) {
            that.saveReservation();
          } else {
            that._throwReservationSaveError();
            return false;
          }
        },
        "click .remove-reservation"(ev) {
          ev.preventDefault();

          if (confirm(that.t("really_remove"))) {
            // First remove reservation from order.reservations-collection,
            // then sync with backend.
            // The process stays the same, even if no reservation.id is present yet
            // ("abort action")

            that.model.collection.remove(that.model).destroy({
              success(model, repsonse) {
                new Notification({
                  message: that.t("removed_${a}", { a: that.t("reservation") }, "capital"),
                  duration: 5000,
                  closeable: true,
                  icon: "fi fi-trash",
                });

                that.model.trigger("changed");
              },
              error() {
                new Notification({
                  message: that.t("removed_${a}", { a: that.t("reservation") }, "capital"),
                  duration: 5000,
                  closeable: true,
                  icon: "fi fi-trash",
                });

                that.model.trigger("changed");
              },
            });
          }
        },
      },
    }).render();

    // get voucher types
    /* console.log("fdfdsdsfdsfd");
        const RequestHelper = Backbone.Model.extend({
            url : '/voucher_types?use_for=reservation'
        });
    
        const requestHelper = (new RequestHelper()).fetch({
            success(model, response) {
                console.log("response: ",response);
                var data = response.data;
                var selects = document.getElementsByName('_voucher_types');
                for (var i=0;i<selects.length;i++) {
                    selects[i].innerHTML = '';
                    var emptyOpt = document.createElement('option');
                    emptyOpt.value = "";
                    selects[i].appendChild(emptyOpt);
                    for (var j=0;j<data.length;j++) {
                        var opt = document.createElement('option');
                        opt.value = data[j].name;
                        opt.innerHTML = data[j].name;
                        selects[i].appendChild(opt);
                    }
                }
            },
            error() {
                console.log('ERROR in get voucher types');
            }
        });
*/
    new Foundation.Abide(this.$el.find("form"), { liveValidate: true });

    window.setTimeout(function () {
      that._setReturnLocations();
      that.model.on(
        "change:begin change:end change:begin_location change:end_location backform:change:date",
        function (a, b) {
          // Check if chosen contingents are still available
          // Before that, make local copy of previous value in order
          // to reset that value in _recheckForRemainingContingents

          if (typeof a !== "undefined" && typeof b !== "undefined") {
            that._previousModelState = {};

            if (typeof a === "object") {
              if (typeof a.changed["begin_location"] !== "undefined") {
                // === begin_location
                that._previousModelState["begin_location"] =
                  that.model._previousAttributes["begin_location"];
              } else {
                // === end_location
                that._previousModelState["end_location"] =
                  that.model._previousAttributes["end_location"];
              }
            } else {
              that._previousModelState[a] = that.model._previousAttributes[a];
            }

            that._recheckForRemainingContingents();
          }
        },
      );

      backformReady = true;

      // Check if begin or end time is out of scope of active openingTimesPeriod
      that.model.on("backform:change:date", (field) => {
        that._checkForOpeningTimeAvailable(field);
      });

      if (that.model.get("id") !== "") {
        that._checkForOpeningTimeAvailable("begin", true);
        that._checkForOpeningTimeAvailable("end", true);
      }

      that.$("input,select").off(".reservationFormNamespace");
      that
        .$("input,select")
        .on("change.reservationFormNamespace", that.onChangeObserver.bind(that));
    }, 1500);

    if (typeof this.model.get("_has_any_deleted_item") === "undefined") {
      // Render contingent sub views
      this._setSummedContingents();
    }

    this.model.on("removedContingent", function (contingentId) {
      // Called from ContingentsOverviewList::_saveContingentsToReservation()
      that._reservationContingentsListViews[contingentId].destroy();
      that.getPrice();
    });
    this.model.on("removedProduct", function (productId) {
      // Called from ContingentsOverviewList::_saveContingentsToReservation()
      that._reservationProductsListViews[productId].destroy();
      $(".product-".productId).remove();
      that.getPrice();
    });
  },

  /**
   * Called after changing begin or end
   * If the set time is outside of available opening time,
   * throw notification
   *
   * @param {string} field  begin || end
   * @param {bool} initialCall Called whilst inital onRender? If so, set outta_timespan-state silently
   */
  _checkForOpeningTimeAvailable(field, initialCall = false) {
    const that = this;

    const locations = Radio.channel("dynamo_start_locations"),
      location_id = Number(this.model.get(field + "_location"));

    if (location_id === 0) {
      return;
    }

    const selectedWeekday = moment(this.model.get(field), "YYYY-MM-DD HH:mm"),
      selectedLocation = locations.request("getLocationById", location_id),
      selectedWeekdayDay = selectedWeekday.format("e"),
      selectedTime = Number(selectedWeekday.format("HH:mm").replace(":", ""));

    if (typeof selectedLocation === "undefined" || selectedLocation === null) {
      // Happens e.g. when return station ID is given, but it's data is not
      return;
    }

    let fieldIsInTime = false;

    const openingTimes = OpeningTimes.getOpeningTimes(
      selectedLocation.get("check_in_periods"),
      selectedWeekday,
    );

    if (openingTimes.activeSeason !== null && typeof openingTimes.activeSeason !== "undefined") {
      const weekday = openingTimes.activeSeason[WeekdaysMap[selectedWeekdayDay]];

      if (weekday !== null && typeof weekday !== "undefined") {
        _.each(weekday, function (openingTime) {
          if (fieldIsInTime) return;

          const begin = Number(openingTime.begin.replace(":", "")),
            end = Number(openingTime.end.replace(":", ""));

          if (selectedTime >= begin && selectedTime <= end) {
            fieldIsInTime = true;
          }
        });
      }

      const inputField = this.$(`.inb-form-group.${field} input.datepicker-time`);

      const timeAlreadyOverriden = inputField.hasClass("is-invalid-input");

      if (!fieldIsInTime) {
        // Selection out of active opening times scope - ask user for permission
        // and a) reset previous time or b) set wished time, but show warning on field

        if (!initialCall && !timeAlreadyOverriden && !confirm(this.t("really_change_time"))) {
          const prevTime = this._previousModelState[field];

          // Reset previous model AND UI state as triggering
          // model.set alone would not force re-render of time fields

          this.model.set(field, prevTime);

          inputField.val(prevTime.substr(11, 5));

          this._previousModelState = {};

          inputField.removeClass("is-invalid-input");

          // Call same routine to check whether the previous time
          // was ALSO out of opening time
          this._checkForOpeningTimeAvailable(field, true);
        } else {
          window.setTimeout(function () {
            // First wait for Backform to re-render field with new time
            that.$(`.inb-form-group.${field} input.datepicker-time`).addClass("is-invalid-input");
          }, 150);
        }
      } else {
        inputField.removeClass("is-invalid-input");
      }
    }

    return true;
  },

  /**
   * Called after changing, begin, end, begin- or end-location
   * Iterates over the selected location to auto-set
   * the begin- or end- time of the selected weekday
   *
   * @param {string} field  begin || end
   * @param {bool} allowFieldOverride Auto-jump to next available period
   */
  _autoSetOpeningTime(field, allowFieldOverride = true) {
    const locations = Radio.channel("dynamo_start_locations"),
      location_id = Number(this.model.get(field + "_location"));

    if (location_id === 0) {
      return;
    }

    const selectedWeekday = moment(this.model.get(field), "YYYY-MM-DD hh:mm"),
      selectedLocation = locations.request("getLocationById", location_id),
      selectedWeekdayDay = selectedWeekday.format("e");

    if (typeof selectedLocation === "undefined" || selectedLocation === null) {
      // Happens e.g. when return station ID is given, but it's data is not
      return;
    }

    let resultTime = null;

    const openingTimes = OpeningTimes.getOpeningTimes(
      selectedLocation.get("check_in_periods"),
      selectedWeekday,
    );

    if (openingTimes.activeSeason !== null && typeof openingTimes.activeSeason !== "undefined") {
      const weekday = openingTimes.activeSeason[WeekdaysMap[selectedWeekdayDay]];

      if (weekday !== null && typeof weekday !== "undefined") {
        _.each(weekday, function (openingTime) {
          if (field === "begin" && resultTime === null) {
            resultTime = openingTime.begin;
          } else if (field === "end") {
            resultTime = openingTime.end;
          }
        });
      }

      if (resultTime) {
        resultTime = selectedWeekday.format("YYYY-MM-DD") + " " + resultTime;
      }
    } else if (
      allowFieldOverride &&
      openingTimes.nextAvailableSeasonPeriod &&
      openingTimes.nextAvailableSeasonPeriod.isAfter(selectedWeekday)
    ) {
      // Time for that day will be set in the next call on _autoSetOpeningTimes()
      resultTime = openingTimes.nextAvailableSeasonPeriod.format("YYYY-MM-DD") + " 00:00";
    }

    if (resultTime && this.model.get(field) !== resultTime) {
      // Only trigger model.set when time actually changed

      const timeAlreadyOverriden = this.$(
        `.inb-form-group.${field} input.datepicker-time`,
      ).hasClass("is-invalid-input");

      if (this.model.get(field) !== resultTime) {
        if (!timeAlreadyOverriden) {
          this.model.set(field, resultTime);

          if (field === "end") {
            this.model.trigger("change:_return_locations", false);
          }
        } else {
          this._checkForOpeningTimeAvailable(field);
        }
      }
    }
  },

  _setSummedContingents() {
    this._reservationContingentsListViews = this._reservationProductsListViews = {};
    this.$el.find(".reservation-contingents-list").html("");

    this.$el.find(".reservation-products-list").html("");
    const that = this;
    let contingentIds = "";
    _.each(this.model.get("summedContingents"), function (collection, key) {
      if (typeof collection.models[0] === "undefined") {
        delete that.model.get("summedContingents")[key];
        return;
      }
      if (contingentIds === "") {
        contingentIds = collection.models[0].get("id");
      } else {
        contingentIds += "," + collection.models[0].get("id");
      }

      // Suddenly, in the middle of nowhere, some wild HTML appears...
      const id = collection.models[0].get("id"),
        el = that.$el
          .find(".reservation-contingents-list")
          .append(`<div class="contingent-${id}"></div>`)
          .find(".contingent-" + id);

      that._reservationContingentsListViews[id] = new ReservationContingentsList({
        collection,
        el,
        reservationView: that,
        originalSelectedUnits: that._originalSelectedUnits,
      });
    });

    /*  this.$el.find('.contingents__add').remove();

    this.$el.find('.reservation-products-list').each(function() {
        $(this).append(`
        <footer class="row contingents__add text-center" style="width:100%;">
        <div style="margin:auto;"><a href="#" class="_button round small hollow"><div id="inb-icon-add_contingent"><div class="lower-right">+</div></div></a></div>
        </footer>
        `)
    });*/
    _.each(this.model.get("summedProducts"), function (collection, key) {
      if (typeof collection.models[0] === "undefined") {
        delete that.model.get("summedProducts")[key];
        return;
      }
      const id = key,
        el = that.$el
          .find(".reservation-contingents-list")
          .append(`<div class="product-${id}"></div>`)
          .find(".product-" + id);

      that._reservationProductsListViews[id] = new ReservationProductsList({
        collection,
        el,
        reservationView: that,
      });
    });
    this.$el.find(".contingents__add").remove();

    this.$el.find(".reservation-products-list").each(function () {
      $(this).append(`
        <footer class="row contingents__add text-center " style="width:100%;">
            <div style="margin:auto;"><a href="#">
                <button type="button" class="inb-round-btn hollow round" style="margin-left: 10px;" title="${that.t("add_contingents_products")}">
                    <div class="inb-fi-add-product"></div>
                </button></a></div>
        </footer>
        `);
    });
  },

  _toggleAccordion(ev) {
    // do not toggle reservation if link on accordion item has been clicked
    if (
      typeof ev.target !== "undefined" &&
      ev.target.className.indexOf("inb-accordion-item-link") != -1
    )
      return;

    if (this.getUI("accordionContent").hasClass("hide")) {
      $("#orders-reservations-accordion .accordion-item .accordion-content").addClass("hide");

      this.getUI("accordionContent").removeClass("hide");
    } else {
      this.getUI("accordionContent").addClass("hide");
    }
  },

  _totalPriceChanged() {
    // Save price in non-float format
    // @todo
    const price = this.model.get("price");
  },

  _hasAllBasicAttributesSet() {
    // Validate for !void
    return (
      this.model.get("begin") &&
      this.model.get("end") &&
      this.model.get("begin_location") &&
      this.model.get("end_location")
    );
  },

  _hasAllRequiredAttributesSet() {
    let hasEmptyCodes = false;

    _.each(this._reservationContingentsListViews, (view) => {
      _.each(view.collection.models, (model) => {
        if (model.get("voucher_type_id") && !model.get("voucher_code")) {
          hasEmptyCodes = true;
        }
      });
    });

    // Final validation, incl. deep scan for contingents
    return (
      this._hasAllBasicAttributesSet() &&
      !_.isEmpty(this.model.get("summedContingents")) &&
      _.some(this.model.get("summedContingents"), (collection) => collection.models.length >= 1) &&
      !hasEmptyCodes
    );
  },

  _validateVouchers() {
    const that = this;
    this.invalidCodes = [];

    _.each(this._reservationContingentsListViews, (view) => {
      _.each(view.collection.models, (model) => {
        if (model.get("voucher_type_id")) {
          let code = model.get("voucher_code");
          let voucher = that.vouchers.models.find(
            (voucherItem) => voucherItem.get("voucher_code") == code,
          );
          if (!voucher || voucher.get("voucher_type_id") !== model.get("voucher_type_id")) {
            that.invalidCodes.push(code);
          }
        }
      });
    });

    return this.invalidCodes.length === 0;
  },

  _throwReservationSaveError() {
    // Invalid form
    let error = this.t("form_validation_error_contingent_form");

    if (
      typeof this.model.validationError !== "undefined" &&
      this.model.validationError !== "" &&
      this.model.validationError !== null
    ) {
      error = this.t(this.model.validationError);
    }

    /* if (typeof this.invalidCodes == 'undefined') {
        this._validateVouchers();
        }

        if (this.invalidCodes && this.invalidCodes.length !== 0) {
            error = this.t('invalid_codes_${a}', {a: this.invalidCodes.join(',')});
        }*/

    this.getUI("errorLabel").removeClass("hide").html(error);

    $("#inb-off-canvas").scrollTop(this.$el.offset().top);
  },

  _getBlockedEnd() {
    // If reservation.blocked_end was set: increase end date by x days
    if (
      this.model.get("blocked_end") !== "" &&
      this.model.get("blocked_end") !== null &&
      Number(this.model.get("blocked_end")) !== NaN
    ) {
      let end = moment(this.model.get("end"), "YYYY-MM-DD HH:mm");

      if (this.model.attributes.blocked_unit == "days") {
        end.add(this.model.get("blocked_end"), "days");
      } else if (this.model.attributes.blocked_unit == "hours") {
        end.add(this.model.get("blocked_end"), "hours");
      }
      return end.format("YYYY-MM-DD HH:mm") + ":00";
    }

    return this.model.attributes.end + (this.model.attributes.end.length < 19 ? ":00" : "");
  },

  /**
   * Called after changes on any form element
   * Indicate whether reservation has to be saved (= was modified)
   */
  onChangeObserver(ref) {
    if (
      typeof this._ui !== "undefined" &&
      typeof this.getUI("reservationRequiresSave") !== "undefined" &&
      typeof this.getUI("accordionContent") !== "undefined"
    ) {
      if (typeof ref === "function" && this.getUI("accordionContent").hasClass("hide")) {
        return; // observer has been called by price update but reservation form is closed -> do not set as unsaved
      }
      this.model.set("_requiresSave", true);
      this.getUI("reservationRequiresSave").removeClass("hide");
    }
  },

  _requestInProgress: false,

  saveReservation(renderOnSuccess = true) {
    if (this.getOption("preventFromSubmit") || this._requestInProgress) {
      return; // required for QuickOrderForm
    }

    this._requestInProgress = true;

    const that = this,
      original = this.model,
      allowedAttributes = [
        "id",
        "order_id",
        "begin",
        "end",
        "contingents",
        "products",
        "status",
        "begin_location",
        "end_location",
        "internal_note",
        "external_note",
        "manual_override",
        "voucher_code",
      ];

    let clone = new Reservation();

    clone.attributes = {
      client_id: Number(Biscuit.get("user.client_id")),
    };

    clone.set("school_bonus", this.model.get("school_bonus") ? 1 : 0);

    if (this.model.get("school_bonus")) {
      clone.set("tag_list", "school_bonus");
    }

    _.each(allowedAttributes, function (attrName) {
      // Whitelist approach
      // Similiar to _.pick

      if (attrName === "contingents") {
        clone.set(
          "contingents_reservations",
          MapContingentsFromRawToSave(that._reservationContingentsListViews),
        );
      } else if (attrName === "products") {
        clone.set("products", MapProductsFromRawToSave(that._reservationProductsListViews));
      } else {
        clone.set(attrName, original.attributes[attrName]);
      }
    });

    if (original.get("id") === "") {
      delete clone.attributes.id;
    }

    if (_.size(clone.get("contingents_reservations")) === 0) {
      this._throwReservationSaveError();
      return;
    }

    // Manually set those values which have to be formatted
    clone.attributes.begin += clone.attributes.begin.length < 19 ? ":00" : "";
    clone.attributes.end += clone.attributes.end.length < 19 ? ":00" : "";
    clone.attributes.blocked_begin = clone.attributes.begin;
    clone.attributes.begin_location = Number(clone.attributes.begin_location);
    clone.attributes.end_location = Number(clone.attributes.end_location);
    clone.attributes.voucher_code;
    if (original.get("manual_override")) {
      clone.attributes.price = Number(original.attributes.price);
    }

    if (original.get("id") == "" && typeof original.get("order") !== "undefined") {
      clone.attributes.order = original.attributes.order;
    }

    clone.attributes.blocked_end = this._getBlockedEnd();

    clone.save(null, {
      type: original.get("id") === "" ? "POST" : "PUT", // just to be sure :)
      success(_model) {
        _model.fetch({
          success(__model) {
            that._requestInProgress = false;

            that.model
              .clear({ silent: true })
              .set(__model.toJSON(), { silent: true })
              .set("_requiresSave", false);

            that.model.trigger("changed");

            new Notification({
              message: that.t("saved_${a}", { a: that.t("reservation") }, "capital"),
              duration: 5000,
              type: "success",
              closeable: true,
              icon: "fi fi-check",
            });

            that.options.toggleOpen = false;

            if (
              typeof that._ui !== "undefined" &&
              that.getUI("reservationRequiresSave") !== "undefined"
            ) {
              that.getUI("reservationRequiresSave")[0].classList.add("hide");
            }

            that.initialize();
            that.render();
            $("#submit-order-status-7").removeClass("hide");
          },
        });
      },
      error(err, xhr) {
        that._requestInProgress = false;
        console.log("request error");

        let response = xhr.responseJSON;
        if (
          typeof response.data != "undefined" &&
          typeof response.data.code != "undefined" &&
          typeof response.data.url != "undefined" &&
          typeof response.data.message != "undefined"
        ) {
          if (
            response.data.code == 422 &&
            response.data.url ==
              ("/api/reservations/" + that.model.id || response.data.url == "/api/reservations")
          ) {
            /*
                    let pairs = response.data.message.split(','),
                        contingentNbr = 0,
                        msg = "";
                    if (pairs.length > 1 && pairs[1].indexOf('Name:') >= 0) {
                        msg = pairs[1].split(':')[1];
                    }   
                    if (pairs.length > 0 && pairs[0].indexOf('Contingent ID:') >= 0) {
                        contingentNbr = Number(pairs[0].split(':')[1]);
                        msg += " (ID: " + contingentNbr + ")";
                    }
                    */
            new Notification({
              message: response.data.message,
              duration: 5000,
              type: "warning",
              closeable: true,
              icon: "fi fi-x",
            });
          }
          return;
        }
        new Notification({
          message: that.t("request_error"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });

        that.model.trigger("request:error");
      },
    });
  },

  _toggleContingentsOverviewView() {
    if (this._hasAllBasicAttributesSet()) {
      const locations = Radio.channel("dynamo_start_locations"),
        begin_location = locations.request("getLocationById", this.model.get("begin_location")),
        end_location =
          this.model.get("end_location") == begin_location.get("id")
            ? begin_location
            : locations.request("getLocationById", this.model.get("end_location"));

      new ContingentsOverviewList({
        begin: this.model.get("begin"),
        end: this._getBlockedEnd(), //this.model.get('end'),
        begin_location,
        end_location,
        parentReservation: this,
      });
    } else {
      alert("Für diese Aktion müssen Start- und Endzeit und -Filialen gewählt sein.");
    }
  },

  _toggleProductsOverviewView() {
    if (this._hasAllBasicAttributesSet()) {
      const locations = Radio.channel("dynamo_start_locations"),
        begin_location = locations.request("getLocationById", this.model.get("begin_location")),
        end_location =
          this.model.get("end_location") == begin_location.get("id")
            ? begin_location
            : locations.request("getLocationById", this.model.get("end_location"));

      new ProductsOverviewList({
        begin: this.model.get("begin"),
        end: this._getBlockedEnd(), //this.model.get('end'),
        begin_location,
        end_location,
        parentReservation: this,
      });
    } else {
      alert("Für diese Aktion müssen Start- und Endzeit und -Filialen gewählt sein.");
    }
  },

  _priceRequestInProgress: false,

  /**
   * @method getPrice
   * Wrapper around _getPrice that keeps calls to API at a minimum level
   */
  getPrice() {
    const that = this,
      locations = Radio.channel("dynamo_start_locations").request("get:data");

    if (!this._priceRequestInProgress) {
      this._priceRequestInProgress = true;

      setTimeout(function () {
        let begin_location = locations.find({
          begin_location_id: that.model.get("begin_location"),
        });
        that._getPrice();
      }, 500);
    }
  },

  /**
   * @method _getPrice
   * Fetch prices from API and inject them into childrenViews
   */
  _getPrice() {
    const that = this,
      locations = Radio.channel("dynamo_start_locations").request("get:data"),
      begin_location = locations.find({ begin_location_id: that.model.get("begin_location") }),
      rab_price_group_id =
        typeof begin_location !== "undefined" ? begin_location.get("rab_price_group_id") : null;

    //if (rab_price_group_id == null) return;

    // Locally re-organize reservation, contingents
    // and pricetariffs data, then trigger getPrice-request

    let result = {
      begin: this.model.get("begin") + (this.model.get("begin").length < 19 ? ":00" : ""),
      end: this.model.get("end") + (this.model.get("end").length < 19 ? ":00" : ""),
      begin_location: Number(this.model.get("begin_location")),
      end_location: Number(this.model.get("end_location")),
      school_bonus: this.model.get("school_bonus") ? 1 : 0,
      manual_override: this.model.get("manual_override") ? 1 : 0,
      reservation_id: this.model.get("id") ? Number(this.model.get("id")) : null,
      order_id: this.model.get("order_id") ? Number(this.model.get("order_id")) : null,
      rab_price_group_id,
    };

    if (Number(Biscuit.get("user.client_id")) !== 7) {
      result.voucher_code = this.model.get("voucher_code");
    }

    if (this.model.get("manual_override")) {
      result.price = Number(this.model.get("price"));
    }

    // The called method will also re-calculate _school_bonus_field_visible
    result.Contingents = MapContingentsFromRawToGetPrice(this._reservationContingentsListViews);
    result.Products = MapProductsFromRawToGetPrice(this._reservationProductsListViews);
    const getPriceHelper = new GetPriceHelper();
    getPriceHelper.save(result, {
      headers: {
        "Accept-Language": Biscuit.get("user.lang").replace("-", "_"),
      },
      success(model, data) {
        let offset = 0;
        let offset2 = 0;

        _.each(that._reservationContingentsListViews, function (view) {
          if (typeof view.injectPricesIntoChildrenViews === "function") {
            view.injectPricesIntoChildrenViews(data.price.Contingents, offset);
            offset += view.collection.models.length;
          }
        });
        _.each(that._reservationProductsListViews, function (view) {
          if (typeof view.injectPricesIntoChildrenProductViews === "function") {
            view.injectPricesIntoChildrenProductViews(data.price.Products, offset2);
            offset2 += view.collection.models.length;
          }
        });

        if (!data.price.school_bonus_available) {
          // Unset any given school bonus
          that.model.set("_school_bonus_field_visible", false);
          that.model.set("school_bonus", false);
        } else {
          that.model.set("_school_bonus_field_visible", true);
        }

        // Required to check whether price was overriden in _setManualOverride
        that.model.set("tariff_price", data.price.tariff_price);

        if (!that.model.get("manual_override")) {
          that.model.set("price", data.price.price);
        }
        if ($("input[name=total_price]").length > 0) {
          $("input[name=total_price]")[0].value =
            data.price.live_order_price + " " + Biscuit.getClientCurrency();
        }

        // @todo i18n
        that.$el
          .find(".inb-form-group.price .help-text")
          .html(data.price.info.replace(/Days/g, "Tag(e)").replace(/for/g, "für"));

        that._priceRequestInProgress = false;
      },
      error() {
        console.log("ERROR getPrice()", result);
        that._priceRequestInProgress = false;
      },
    });
  },
});
